/**
 * As datas, num lugar só.
 *
 * <p>Fuso de São Paulo e formato brasileiro, fixos — e não o do navegador. Um painel de
 * operação que mostra o horário do computador de quem abriu faz duas pessoas lendo a mesma
 * tela discordarem sobre quando a carga saiu, e é o tipo de divergência que só aparece na
 * hora de apurar um incidente.
 */

const FUSO = 'America/Sao_Paulo';

const DATA_HORA = new Intl.DateTimeFormat('pt-BR', {
  timeZone: FUSO,
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

const DATA = new Intl.DateTimeFormat('pt-BR', {
  timeZone: FUSO,
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
});

function parse(valor: string | null | undefined): Date | null {
  if (!valor) {
    return null;
  }
  const d = new Date(valor);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function emDataHora(valor: string | null | undefined): string {
  const d = parse(valor);
  return d ? DATA_HORA.format(d) : '—';
}

export function emData(valor: string | null | undefined): string {
  const d = parse(valor);
  return d ? DATA.format(d) : '—';
}

/** Hexadecimal longo encurtado para caber na tabela — com o começo E o fim. */
export function hashCurto(valor: string | null | undefined, pontas = 6): string {
  if (!valor) {
    return '—';
  }
  if (valor.length <= pontas * 2 + 1) {
    return valor;
  }
  return `${valor.slice(0, pontas)}…${valor.slice(-pontas)}`;
}
